export default {
  release: '16.6',
  date: 'November 2023',
  releasePostUrl: 'https://docs.gitlab.com/releases/16/gitlab-16-6-released/#this-months-notable-contributor-joe-snyder',
  contributors: [
    {
      name: 'Joe Snyder',
      gitlabUsername: 'joe-snyder',
    },
  ],
  writeUp: `Joe Snyder was awarded GitLab's 16.6 MVP for consistent contributions across GitLab, including
recent merge requests to [allow admins to filter runners by version](https://gitlab.com/gitlab-org/gitlab/-/merge_requests/135025).

Joe was nominated by [Miguel Rincon](https://gitlab.com/mrincon), Staff Frontend Engineer at GitLab.
Miguel recognized Joe's efforts through several required rewrites due to GitLab's evolving architecture
and commented on Joe's "thoughtful consideration of performance and usability."

[Pedro Pombeiro](https://gitlab.com/pedropombeiro), Sr. Backend Engineer at GitLab, added that "Joe Snyder drove this change over the
finish line after taking over from a former colleague, requiring learning all the context around the problem.
He also proved very responsive and patient with our feedback in successive reviews."

"Joe has been a pleasure to work with," said [Terri Chu](https://gitlab.com/terrichu), Staff Backend Engineer at GitLab.
Terri highlighted Joe's ongoing work on [\`emails_enabled\` changes](https://gitlab.com/gitlab-org/gitlab/-/merge_requests/127899)
over the last (and previous) milestone.

Joe Snyder is a Senior R&D Engineer at [Kitware](https://www.kitware.com/) and has been contributing to GitLab since 2021.
Our many thanks to Joe for continuing to improve GitLab!`,
};
